
const CreateTextComponent_mutate = `
    mutation createTextComponent(
      $label: String!
      $formId: Int!
      $mandatory: Boolean
      $caption: String
      $tooltip: String
      
      $maxLength: Int!
      ) {
      createTextComponent(                
        label: $label,
        formId: $formId,
        mandatory: $mandatory,
        caption: $caption,
        tooltip: $tooltip,
        
        maxLength: $maxLength) {
         answer
            {
              answerId
              componentId
              {
                formId
                {
                  name
                  clientId
                  {
                    tenantId
                    {
                      name
                    }
                    name
                  }
                }
                componentId
                label
                mandatory
                caption
                tooltip
                order
              }
              label
              value
              score
              order
              maxLength
              width
              height
            }
                  
      }
    }
`;

const EditTextComponent_mutate = `
  mutation editTextComponent(
    $componentId: Int!
    $label: String 
    $mandatory: Boolean
    $caption: String
    $tooltip: String
    $maxLength: Int
    ) {
    editText(
      componentId: $componentId,
      label: $label,
      mandatory: $mandatory,
      caption: $caption,
      tooltip: $tooltip,
      maxLength: $maxLength) 
      {
        component {
          componentId
          answerList{
            answerId 
            label
            value
          }
          caption
          tooltip
          label
          mandatory          
        }
      }
    }
`;


module.exports = {  
  
  CREATE_TEXT_COMPONENT_MUTATION : CreateTextComponent_mutate,
  EDIT_TEXT_COMPONENT_MUTATION : EditTextComponent_mutate
  
}
